var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"success"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/cloudWarehouse/success.png"),"alt":""}}),_c('div',{staticClass:"tip"},[_vm._v("订单已出库成功！")]),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onConfirm()}}},[_vm._v("返回云仓库")])])
}
var staticRenderFns = []

export { render, staticRenderFns }